module.exports = __webpack_public_path__ + "img/logo2.a2d4d88d.png";